<template>
  <v-container fluid>
    <div id="content">

      <section class="d-flex">
        <BreadCrumb :items="$route.matched"></BreadCrumb>
      </section>

      <section class="list">
        <h3>
          条件を指定して検索
          <div class="ctrl-btn opened" @click="switchAccordion"></div>
        </h3>
        <div class="accordion_inner">
          <v-row>
            <v-col cols="6" md="3">
              <v-combobox
                ref="department"
                label="所属部署"
                v-model="filterKeyword.department"
                :items="departments"
                append-icon="fas fa-list-ol"
                @click.stop="openSelected('department')"
                @change="filterChange"
                readonly outlined clearable hide-details="auto">
              </v-combobox>
            </v-col>
            <v-col cols="4" md="2">
              <v-btn 
                @click="searchFunc" 
                color="primary"
                text x-large>
                  <v-icon left>fas fa-search</v-icon>
                  検索する
                </v-btn>
            </v-col>
          </v-row>
        </div>

        <div v-if="search">
          <h3 class="mt-5">検索結果</h3>
          <v-sheet class="d-flex justify-space-between">
            <v-btn icon class="ma-2" @click="prev">
              <v-icon>fas fa-chevron-left</v-icon>
            </v-btn>
            <div class="year-title">
              {{ yearTitle }}
            </div>
            <v-btn icon class="ma-2" @click="next">
              <v-icon>fas fa-chevron-right</v-icon>
            </v-btn>
          </v-sheet>
          <v-row v-if="!loading">
            <v-col cols="3" md="1" class="left-table">
              <v-data-table
                :headers="leftHeaders"
                :items="filterItems"
                no-data-text=""
                dense
                hide-default-footer
                disable-pagination>
                <template v-slot:body="{ items, headers }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="'left_' + index">
                      <th>{{ item.month }}</th>
                    </tr>
                    <tr>
                      <th :colspan="headers.length">合計</th>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="6" md="10" class="center-table">
              <v-data-table
                :headers="centerHeaders"
                :items="filterItems"
                dense
                hide-default-footer
                disable-pagination>
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, i) in items" :key="'month_' + i">
                      <td class="text-right" v-for="(user, j) in centerHeaders" :key="'user_' + i + '_' + j">
                        <template v-if="user.userID">
                          {{ getMonthUserTotal(i, user.userID) }}
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right" v-for="(user, j) in centerHeaders" :key="'user_' + j">
                        <template v-if="user.userID">
                          {{ getUserTotal(user.userID) }}
                        </template>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
            <v-col cols="3" md="1" class="right-table">
              <v-data-table
                :headers="rightHeaders"
                :items="filterItems"
                no-data-text=""
                dense
                hide-default-footer
                disable-pagination>
                <template v-slot:body="{ items, headers }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="'right_' + index">
                      <td class="text-right">{{ getMonthTotal(index) }}</td>
                    </tr>
                    <tr>
                      <td :colspan="headers.length" class="text-right">
                        {{ total }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <div v-if="loading">
            <v-progress-linear
              indeterminate></v-progress-linear>
          </div>
        </div>

      </section>

    </div>
  </v-container>
</template>

<script>
import { API, graphqlOperation } from 'aws-amplify'
import { 
  listAppOptions, listUsers, listDialies,
  listEvents, listWorkTimeGroups, getWorkTimeGroup, listWorkTypes } from '../graphql/queries'
import { 
  onCreateUser, onUpdateUser, onDeleteUser } from '../graphql/subscriptions'
import moment from 'moment'

export default {
  data() {
    return {
      search: false,
      loading: false,
      leftHeaders: [
        { text: '月', align: 'start', value: 'month', sortable: false },
      ],
      rightHeaders: [
        { text: '合計', align: 'end', value: 'sum', sortable: false },
      ],
      appOptions: {},
      desserts: [],
      users: [],
      worktimes: [],
      events: [],
      filterKeyword: {},
      calendar: null,
      viewDate: false,
      worktypes: [],
    }
  },
  prop: {},
  mounted: async function() {
    //this.load(true)
    //設定 query
    const appOptionQuery = await API.graphql(graphqlOperation(listAppOptions, { limit: 100 }))
    for (const row of appOptionQuery.data.listAppOptions.items) {
      this.appOptions[row.name] = row.value
    }
    //ユーザーリスト query
    await this.getUsers()
    //労務・休憩時間 query
    await this.getWorkTimeGroups()
    //作業種別 query
    await this.getWorkTypes()

    //作成時 subscription
    await API.graphql(graphqlOperation(onCreateUser)).subscribe({
      next: (e) => {
        const row = e.value.data.onCreateUser
        this.users.push(row)
      }
    })
    //更新時 subscription
    await API.graphql(graphqlOperation(onUpdateUser)).subscribe({
      next: (e) => {
        const row = e.value.data.onUpdateUser
        this.users.find(origin => {
          if (origin.id === row.id) {
            origin = Object.assign(origin, row)
          }
        })
      }
    })
    //削除時 subscription
    await API.graphql(graphqlOperation(onDeleteUser)).subscribe({
      next: (e) => {
        const row = e.value.data.onDeleteUser
        this.users = this.users.filter(origin => origin.id !== row.id)
      }
    })
    //起算日の算出
    const closing = parseInt(this.appOptions.closing)
    const date = moment().month(parseInt(this.appOptions.calcMonth)-1).date(closing)
    
    if (closing > 0) {
      date.subtract(1, 'month').add(1, 'day')
    } else {
      date.startOf('month').add(1, 'month')
    }
    
    if (date > moment()) date.subtract(1, 'year')
    this.calendar = moment(date).format('YYYY-MM-DD')

    //日報の取得
    //await this.queryDialy()

    //this.load(false)
  },
  beforeDestroy() {},
  created() {
    if (!this.isAllowed(this.$route.name)) this.$router.push('/')
  },
  computed: {
    filterItems() {
      const map = []
      
      if (this.calendar) {

        //期間の算出
        for (let i=0; i<12; i++) {
          const start = moment(this.calendar).add(i, 'month')
          const end = moment(start)
          const closing = parseInt(this.appOptions.closing)
          if (closing > 0) {
            end.add(1, 'month').date(closing)
          } else {
            end.endOf('month')
          }

          map.push({
            start: moment(start).format('YYYY-MM-DD'),
            end: moment(end).format('YYYY-MM-DD'),
            month: moment(end).format('M月'),
            items: [],
          })
        }

        for (const item of this.desserts) {
          //所属部署
          if (this.filterKeyword.department && this.filterKeyword.department != item.user.department) continue

          const month = map.find(e => moment(e.start) <= moment(item.start) && moment(e.end) >= moment(item.start))
          const user = month.items.find(e => e.id == item.user.id)

          let sum = 0
          let overTime = 0, midnightTime = 0
          let start = null, end = null
          let holiday = false
          let addTime = 0

          //作業時間のソート
          item.works.items.sort(function(a, b) {
            if (a.start < b.start) return -1
            if (a.start > b.start) return 1
          })
          //総時間
          for (const work of item.works.items) {
            if (!start) start = moment(moment(work.start, 'X').format('HH:mm'), 'HH:mm')
            end = moment(moment(work.end, 'X').format('HH:mm'), 'HH:mm')
          }
          //終業時刻が日を跨ぐか
          if (end && end.hour() == 0) end.add(1, 'days')

          //休日かどうか
          holiday = this.isHoliday(item.start)

          let subtractTime = 0
          for (const work of item.works.items) {
            //残業・深夜
            const time = this.diffSectionTime(
              moment(work.start, 'X').format('HH:mm'),
              moment(work.end, 'X').format('HH:mm'),
              this.getWorkTimes(item.start),
            )
            //通常
            sum += time.sum
            //残業
            overTime += time.over
            //深夜
            midnightTime += time.midnight

            //代休・振休
            const worktype = this.worktypes.find(e => e.id == work.worktypeID)
            const transfer = this.diffTime(
              moment(work.start, 'X').format('HH:mm'),
              moment(work.end, 'X').format('HH:mm'),
              true, 
              this.getWorkTimes(item.start)
            )
            switch(worktype.name) {
              case '代休':
              case '振休':
                subtractTime += transfer
                break

              default:
                break
            }
          }
          
          //就業時間集計
          if (!holiday) {
            addTime = overTime + midnightTime

          } else {
            //addTime = sum - restTime
            addTime = sum + overTime + midnightTime
          }

          if (!user) {
            month.items.push({
              id: item.user.id,
              sum: addTime - subtractTime,
            })

          } else {
            user.sum += addTime - subtractTime
          }
        }

      }
      
      return map
    },
    centerHeaders() {
      const map = []

      for (const item of this.users) {
        //所属部署
        if (this.filterKeyword.department && this.filterKeyword.department != item.department) continue

        const name = item.last + ' ' + item.first
        if (!map.find(e => e.text == name)) {
          map.push({
            text: name,
            userID: item.id,
            align: 'end',
            width: 150,
            sortable: false
          })
        }
      }

      map.push({ 
        text: '', 
        userID: null,
        align: 'end', 
        sortable: false
      })

      return map
    },
    departments() {
      const map = []

      for (const item of this.users) {
        if (!map.find(e => e == item.department) && item.department) map.push(item.department)
      }

      //名前順でソート
      map.sort(function(a,b) {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      
      return map
    },
    //カレンダーのタイトル
    yearTitle() {
      if (this.calendar) {
        return moment(this.calendar).format('YYYY年度') + ' (' + 
          moment(this.start).format('YYYY-MM-DD') + ' ～ ' + moment(this.end).format('YYYY-MM-DD') + ')'
      }
      return ''
    },
    //年度始まり
    start() {
      let date = moment()

      if (this.calendar) {
        date = moment(this.calendar)
      }

      return date.format('YYYY-MM-DD')
    },
    //年度終わり
    end() {
      let date = moment()

      if (this.calendar) {
        date = moment(this.calendar)
        const closing = parseInt(this.appOptions.closing)
        if (closing > 0) {
          date.add(1, 'year').date(closing)
        } else {
          date.add(1, 'year').subtract(1, 'month').endOf('month')
        }
      }

      return date.format('YYYY-MM-DD')
    },
    //合計
    total() {
      let sum = 0

      for (const month of this.filterItems) {
        for (const user of month.items) {
          sum += user.sum
        }
      }

      return sum
    },
  },
  watch: {

  },
  methods: {
    //初期化
    async init() {

    },
    //検索
    async searchFunc() {
      this.search = true
      this.loading = true
      await this.queryDialy()
    },
    //条件変更
    filterChange() {
      this.search = false
    },
    //年度戻り
    prev() {
      this.calendar = moment(this.calendar).subtract(1, 'year').format('YYYY-MM-DD')
      this.queryDialy()
    },
    //年度進み
    next() {
      this.calendar = moment(this.calendar).add(1, 'year').format('YYYY-MM-DD')
      this.queryDialy()
    },
    //日報データ取得
    async queryDialy() {
      this.loading = true
      this.desserts = []
      this.events = []

      await this.getDialys()
    },
    //カレンダー表示日
    dateFormat() {
      this.calendar = moment(this.calendar).format('YYYY-MM-DD')
    },
    //休日判定
    isHoliday(dateStr) {
      let holiday = false
      //休日かどうか
      for (const item of this.events) {
        if (moment(item.start) <= moment(dateStr) && 
            moment(item.end) >= moment(dateStr)) {
          holiday = true
          break
        }
      }
      return holiday
    },
    //ユーザー毎の月別集計
    getMonthUserTotal(index, id) {
      if (this.filterItems[index]) {
        const item = this.filterItems[index].items.find(e => e.id == id)

        return item ? item.sum : 0
      }
      return 0
    },
    //月別集計
    getMonthTotal(index) {
      let sum = 0

      if (this.filterItems[index]) {
        for (const item of this.filterItems[index].items) {
          sum += item.sum || 0
        }
      }

      return sum
    },
    //ユーザー集計
    getUserTotal(id) {
      let sum = 0

      for (const month of this.filterItems) {
        const item = month.items.find(e => e.id == id)
        sum += item ? item.sum : 0
      }

      return sum
    },
    //労務時間の取得
    getWorkTimes(date) {
      const map = []

      if (date) {
        for (const item of this.worktimes) {
          if (item.start <= date && item.end >= date) {
            return item.workTimes

          } else if (item.end >= date) {
            return item.workTimes

          } else if (item.start <= date) {
            return item.workTimes
          }
        }
      }

      return map
    },
    //アコーディオンの開閉
    switchAccordion(e) {
      const target = e.target.parentElement.nextSibling
      target.style.display = target.style.display == 'none' ? 'block' : 'none'
      e.target.classList.toggle('opened')
    },
    //ユーザーの取得
    async getUsers(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listUsers, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listUsers.items) {
        this.users.push(data)
      }
      if (query.data.listUsers.nextToken) this.getUsers(query.data.listUsers.nextToken)
    },
    //日報情報の取得
    async getDialys(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listDialies, {
        filter: {
          and: [
            { start: { ge: this.start } },
            { start: { le: this.end } },
          ],
        },
        limit: 1000,
        nextToken: nextToken
      }))
      for (const row of query.data.listDialies.items) {
        this.desserts.push(row)
      }
      if (query.data.listDialies.nextToken) {
        this.getDialys(query.data.listDialies.nextToken)

      } else {
        //休日・イベントを取得
        await this.getEvents()
        this.loading = false
      }
    },
    //イベントの取得
    async getEvents(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listEvents, {
        filter: {
          and: [
            { start: { ge: moment(this.start).subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') } },
            { end: { le: moment(this.end).format('YYYY-MM-DDTHH:mm:ss') } },
          ],
        },
        limit: 1000,
        nextToken: nextToken
      }))
      for (const data of query.data.listEvents.items) {
        this.events.push(data)
      }
      if (query.data.listEvents.nextToken) this.getEvents(query.data.listEvents.nextToken)
    },
    //労務・休憩時間の取得
    async getWorkTimeGroups(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTimeGroups, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTimeGroups.items) {
        const ret = await API.graphql(graphqlOperation(getWorkTimeGroup, { id: data.id }))
        const items = ret.data.getWorkTimeGroup.workTimes.items

        items.sort(function(a, b) {
          if (a.start < b.start) return -1
          if (a.start > b.start) return 1
        })
        data.workTimes = items

        this.worktimes.push(data)
      }
      if (query.data.listWorkTimeGroups.nextToken) {
        this.getWorkTimeGroups(query.data.listWorkTimeGroups.nextToken)
      }
    },
    //作業種別の取得
    async getWorkTypes(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listWorkTypes, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listWorkTypes.items) {
        this.worktypes.push(data)
      }
      if (query.data.listWorkTypes.nextToken) this.getWorkTypes(query.data.listWorkTypes.nextToken)
    },
  },
  components: {
    
  },
}
</script>

<style lang='scss' scoped>
.year-title {
  line-height: 52px;
}
.left-table {
  padding-right: 0;
}
.center-table {
  padding-left: 0;
  padding-right: 0;
}
.right-table {
  padding-left: 0;
}
tbody {
  tr {
    &:hover {
      background: transparent !important;
    }
    &.ghost {
      opacity: 0.5 !important;
      background: #c8ebfb !important;
    }
  }
}
</style>
